module.exports = __webpack_public_path__ + "static/media/HS5105HJ.19808665.jpg";